export abstract class SerializableMetaData {
}

